import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-8 flex flex-col justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-12" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-semibold text-gray-900 text-2xl mb-4" }, "Measurement Checklist"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 font-medium" }, " To ensure accurate measurements are recorded we would like your state of exertion to be consistent with the following: ")
], -1)
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("I have rested for 5 minutes")
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" I have a warm hand and will try multiple fingers if needed ")
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("I will take results when readings are steady")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Ready to Add Measurements ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MeasurementChecklistItem = _resolveComponent("MeasurementChecklistItem")!
  const _component_IonButton = _resolveComponent("IonButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_3, [
        _createVNode(_component_MeasurementChecklistItem, { class: "w-full" }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createVNode(_component_MeasurementChecklistItem, { class: "w-full" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createVNode(_component_MeasurementChecklistItem, { class: "w-full" }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_IonButton, {
      color: "primary",
      expand: "block",
      fill: "solid",
      size: "large",
      class: "mt-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$emit('ready')))
    }, {
      default: _withCtx(() => [
        _hoisted_9
      ]),
      _: 1
    })
  ]))
}